import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { brandUrl } from '../brand/brand-context';

/**
 * `/reservation/service-booking` -> `/bookings`, keeping the query string
 * (`reservationId`, `edit`, `cancel`) and fragment, in whichever URL form
 * the visitor arrived with (with or without the brand flavour). Reservations
 * booked before the move carry WebComponent "reservation/service-booking",
 * so the emails they generate keep landing here for as long as they can be
 * changed or cancelled - this redirect is permanent.
 */
@Injectable({ providedIn: 'root' })
export class LegacyBookingRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    const current = this.router.parseUrl(state.url);
    const tree = this.router.parseUrl('/' + brandUrl('bookings'));
    tree.queryParams = current.queryParams;
    tree.fragment = current.fragment;
    return tree;
  }
}
